import baseRoute from '../baseRoute';

type RouteDefinition = typeof baseRoute | `${typeof baseRoute}?group=${string}&search=${string}&page=${string}`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = baseRoute;

export const URL = (group: string, search: string, page: number): RouteDefinition => `${baseRoute}?group=${group}&search=${search}&page=${page}`;
